import { getLocalStorage } from "@/utilities/common";
import { useStore } from "@/utilities/storeHook";
import { Spinner } from "@fluentui/react";
import { Avatar, FluentProvider, Toast, ToastIntent, ToastPosition, ToastTitle, Toaster, useId, useToastController } from "@fluentui/react-components";
import { unifiedTeamsLightTheme } from "@/themes/fluentThemes";
import React, { CSSProperties, useEffect } from "react";
interface IBZAToastProps {
  status?: ToastIntent | "progress" | "avatar";
  isShow?: boolean;
  message?: string;
  inline?: boolean;
  position?: ToastPosition;
  style?: CSSProperties
}

const BZAToast = (props: IBZAToastProps) => {
  const { status = "success", isShow = false, message = "提示信息", inline = false, position = "top", style = {} } = props;
  const { commonStore } = useStore();
  const toasterId = useId("toaster");
  const { dispatchToast } = useToastController(toasterId);
  const [intent, setIntent] = React.useState<ToastIntent | "progress" | "avatar">(status);
  let currentInfo = JSON.parse(getLocalStorage("toastConfig") as string);
  const notify = (status: ToastIntent | "progress" | "avatar") => {
    switch (status) {
      case "progress":
        dispatchToast(
          <Toast>
            <ToastTitle media={<Spinner size={1} />}>
              {message}
            </ToastTitle>
          </Toast>
        );
        break;
      case "avatar":
        dispatchToast(
          <Toast>
            <ToastTitle media={<Avatar name="Erika Mustermann" size={16} />}>
              {message}
            </ToastTitle>
          </Toast>
        );
        break;
      case "error":
      case "info":
      case "success":
      case "warning":
        dispatchToast(
          <Toast>
            <ToastTitle>{message}</ToastTitle>
          </Toast>,
          { position, intent: status, timeout: !isShow ? -1 : 2000 }
        );
        break;
    }
  };
  useEffect(() => {
    if (currentInfo) {
      currentInfo.show = false;
    }
    commonStore.setToastConfig(currentInfo);
    setIntent(status);
    if (isShow) {
      notify(status);
    }
  }, [isShow, intent]);

  return (
    <FluentProvider theme={unifiedTeamsLightTheme}>
      <Toaster toasterId={toasterId} inline={inline} position={position} />
    </FluentProvider>
  );
};

export default BZAToast;
